export default "__VITE_ASSET__DJqz7F6F__"